<template>
  <div class="sidebar__row sidebar__row--logout">
    <nav :class="`${classPrefix}`">
      <ul :class="`${classPrefix}__links`">
        <li class="sidebar__signout" :class="`${classPrefix}__link-item`">
          <a href="/logout/" @click.prevent="logout">
            <div class="sidebar__signout-icon" :class="`${classPrefix}__link-icon`"><i class="fa fa-sign-out-alt"></i></div>
            <p :class="`${classPrefix}__link`">Sign out</p>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
  export default {
    name: 'LogoutItem',
    props: {
      classPrefix: {
        type: String,
        default: 'links-col',
      },
    },
    methods: {
      logout() {
        this.$store.dispatch('main/setProperty', { key: 'globalLoading', value: true });
        this.$store.dispatch('auth/logout');
      },
    },
  };
</script>
